/**
 * Cover/Chapter metadata fetch (lazy, non-blocking).
 *
 * Hits zapd's item/cover/by-path endpoint to get poster + chapters JSON. The endpoint
 * is auth-aware (Zap-SPA uses cookies/Bearer; Filmdir uses cookies). Failures
 * are silent — chapters are non-critical.
 */

export async function fetchCoverMeta(rawPath) {
  if (!rawPath) return null;
  try {
    const r = await fetch('/api-zapd/item/cover/by-path?path=' + encodeURIComponent(rawPath), {
      credentials: 'include',
    });
    if (!r.ok) return null;
    const d = await r.json();
    return d?.cover || d?.data?.cover || null;
  } catch {
    return null;
  }
}
